import React, { useEffect, useState } from "react";
import UserSidebar from "./UserSidebar";

const UserDomains = () => {
  const [domains, setDomains] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchUserDomains() {
      const host = import.meta.env.VITE_HOST;
      const port = import.meta.env.VITE_PORT;
      const token = localStorage.getItem("jwt_token");
      const userId = localStorage.getItem("user_id");

      if (!token || !userId) {
        setError("Token o user ID mancante. Effettua il login.");
        setLoading(false);
        return;
      }

      try {
        const res = await fetch(
          `${host}:${port}/api/v1/users/get_user_domain?_id=${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const json = await res.json();
        if (res.ok) {
          setDomains(json.data || []);
          setError("");
        } else {
          setError(json.detail || json.message || "Errore durante il recupero dei domini.");
        }
      } catch (err) {
        setError("Errore nella richiesta al server.");
      } finally {
        setLoading(false);
      }
    }

    fetchUserDomains();
  }, []);

  return (
    <div className="flex h-[calc(100vh-40px)] bg-white">
      <UserSidebar />

      <main className="flex-1 px-6 py-6 overflow-y-auto">
        <h1 className="text-3xl font-bold mb-8" style={{ color: "#94c41c" }}>
          I tuoi Domini Acquistati
        </h1>

        {loading && (
          <p className="text-gray-600">Caricamento domini in corso...</p>
        )}

        {error && (
          <p className="text-red-500 mb-4">
            {error}
          </p>
        )}

        {!loading && !error && domains.length === 0 && (
          <p className="text-gray-700">Non hai ancora acquistato nessun dominio.</p>
        )}

        {!loading && domains.length > 0 && (
          <div className="space-y-6">
            {domains.map((domain) => (
              <div
                key={domain.domain_id}
                className="border rounded-lg shadow p-5 bg-white hover:shadow-lg transition-shadow"
              >
                <h2 className="text-2xl font-semibold mb-2 text-gray-900">
                  {domain.domain_name}
                  {domain.domain_extension}
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-700">
                  <div>
                    <strong>ID Dominio:</strong> {domain.domain_id}
                  </div>
                  <div>
                    <strong>Categoria:</strong> {domain.category_name || "N/A"}
                  </div>
                  <div>
                    <strong>Prezzo (€):</strong> {domain.domain_price?.toFixed(2) || "0.00"}
                  </div>
                  <div>
                    <strong>Data Acquisto:</strong>{" "}
                    {new Date(domain.creation_date).toLocaleString()}
                  </div>
                  {domain.expiration_date && (
                    <div>
                      <strong>Data Scadenza:</strong>{" "}
                      {new Date(domain.expiration_date).toLocaleDateString()}
                    </div>
                  )}
                  {domain.status && (
                    <div>
                      <strong>Stato:</strong> {domain.status}
                    </div>
                  )}
                  {domain.additional_info && (
                    <div className="md:col-span-2">
                      <strong>Info aggiuntive:</strong> {domain.additional_info}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default UserDomains;
